import React from "react";
import useStudioAccount from "./useStudioAccount";
import StudioGate from "./StudioGate";
import CaseList from "../rightsClaims/CaseList";
import StrikeList from "../rightsClaims/StrikeList";
import TermsDisclosures from "./TermsDisclosures";

// Artist Studio > Rights & Legal. Strikes only appear once the platform raises them (empty state until then); they are read from /v1/artist-strike/mine.
// Notices (copyright notices and counter-notices) and Claims (ownership disputes) are live cases from
// /v1/rights-claim: the ones filed against this artist's sounds and the ones they filed themselves.
const TABS = {
  strikes: {
    columns: ["Track", "Reason", "Date", "Status"],
    empty: "No strikes on record.",
  },
  notices: {
    columns: ["Track", "Notice", "Received", "Status"],
    empty: "No notices received.",
  },
  claims: {
    columns: ["Track", "Claimant", "Date", "Status"],
    empty: "No claims received.",
  },
};

export default function RightsLegal({ tab = "strikes" }) {
  const account = useStudioAccount();
  return (
    <StudioGate account={account} active="rights" heading="Rights & Legal" maxWidth="max-w-6xl">
      {tab === "strikes" && <StrikeList columns={TABS.strikes.columns} empty={TABS.strikes.empty} />}
      {tab === "notices" && <CaseList types={["copyright_notice", "counter_notice"]} empty={TABS.notices.empty} />}
      {tab === "claims" && <CaseList types={["ownership_dispute"]} variant="claims" empty={TABS.claims.empty} />}
      {tab === "terms" && <TermsDisclosures />}
    </StudioGate>
  );
}
